import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { LoadingDialog } from "../../../../../../_metronic/_partials/controls";

export function OrderLoading() {
    const { isLoading } = useSelector((state) => (
        { isLoading: state.order.listLoading }
    ));

    useEffect(() => { }, [isLoading]);
    return <LoadingDialog isLoading={isLoading} text="Loading...." />;
}